import { MediaControls } from '@source-digital/embed-core'

export class PlyrMediaControls implements MediaControls {
  constructor (private readonly _plyr: () => Plyr) {}

  get plyr () {
    return this._plyr()
  }

  on (ev: Parameters<MediaControls['on']>[0], handler: (data?: any) => void): MediaControls {
    this.plyr.on(ev as any, handler)
    return this
  }

  off (ev: Parameters<MediaControls['off']>[0], handler: (data?: any) => void): MediaControls {
    this.plyr.off(ev as any, handler)
    return this
  }

  play (): void {
    const playPromise = this.plyr.play()
    if (playPromise !== undefined) {
      playPromise.catch(console.warn)
    }
  }

  pause (): void {
    this.plyr.pause()
  }

  get paused () {
    return this.plyr.paused
  }

  get currentTime () {
    return this.plyr.currentTime
  }

  get duration () {
    return this.plyr.duration
  }

  get muted () {
    return this.plyr.muted
  }

  get currentSrc () {
    // todo fix this
    return this.plyr.source.tracks?.[this.plyr.currentTrack]?.src
  }

  setCurrentTime (seconds: number): void {
    this.plyr.currentTime = seconds
  }

  mute (muted: boolean): void {
    this.plyr.muted = muted
  }

  setVolume (value: number): void {
    this.plyr.volume = value
  }

  get volume (): number {
    return this.plyr.volume
  }

  getVolume (): number {
    return this.plyr.volume
  }
}
